<template>
  <div class="customer-service-message">
    {{ displayText }}
  </div>
</template>
<script setup lang="ts">
import { computed } from '../../../adapter-vue';
import { IMessageModel } from '@tencentcloud/chat-uikit-engine';
import { JSONToObject } from '../../../utils/type-check';

interface IProps {
  message: IMessageModel;
}
const props = withDefaults(defineProps<IProps>(), {
  message: () => ({} as IMessageModel),
});

const displayText = computed(() => {
  const payloadData = JSONToObject(props.message?.payload?.data);
  return payloadData?.text || payloadData?.content || payloadData?.description || '[客服消息]';
});
</script>
<style lang="scss" scoped>
.customer-service-message {
  padding: 12px;
  font-size: 14px;
  word-break: break-word;
}
</style>
